import { createAction } from '@reduxjs/toolkit'
import {
    IdTicketsStateDataItem, typeMerchantData,
    typeTicketResponse,
    typeTicketsFilters
} from 'model/dashboardTickets/dTicketsReducer';

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data
export const dTicketsSetDataAC = createAction(
    'D_TICKETS_SET_DATA',
    ( dataList: IdTicketsStateDataItem[] ) => ( { payload: { dataList } } )
)

// Action creator of saga set data
export const dTicketsSetDataSagaAC = createAction(
    'D_TICKETS_SET_DATA_SAGA',
    (
        filters: typeTicketsFilters
    ) => ( { payload: { filters } } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data detail
export const dTicketsSetDetailItemAC = createAction(
    'D_TICKETS_SET_DETAIL_ITEM',
    ( detailItemId: string ) => ( { payload: detailItemId } )
)
// ---------------------------------------------------------------------------------------------------------------------
// Action creator of add item
export const dTicketsAddItemAC = createAction(
    'D_TICKETS_ADD_ITEM',
    (detailItemObject: IdTicketsStateDataItem) => ({payload: detailItemObject})
)

// Action creator of saga add item
export const dTicketsAddItemSagaAC = createAction(
    'D_TICKETS_ADD_SAGA_ITEM',
    (
        itemObject: {name: string, description: string, status: string},
        filters: typeTicketsFilters,
    ) => ({payload: {itemObject, filters}})
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of edit data
export const dTicketsEditItemAC = createAction(
    'D_TICKETS_EDIT_ITEM',
    ( detailItemObject: IdTicketsStateDataItem ) => ( { payload: detailItemObject } )
)

// Action creator of saga edit data
export const dTicketsEditItemSagaAC = createAction(
    'D_TICKETS_EDIT_SAGA_ITEM',
    (
        detailItemObject: IdTicketsStateDataItem,
        filters: typeTicketsFilters ) => ( { payload: { detailItemObject,  filters } } )
)
// ---------------------------------------------------------------------------------------------------------------------
// Action creator of saga add response
export const dTicketsAddResponseItemSagaAC = createAction(
    'D_TICKETS_ADD_RESPONSE_SAGA_ITEM',
    (
        detailItemObject: typeTicketResponse,
        filters: typeTicketsFilters ) => ( { payload: { detailItemObject, filters } } )
)
// Action creator of saga edit response
export const dTicketsSetResponseViewedItemSagaAC = createAction(
    'D_TICKETS_SET_RESPONSE_VIEWED_SAGA_ITEM',
    (
        detailItemObject: typeTicketResponse,
        filters: typeTicketsFilters ) => ( { payload: { detailItemObject,  filters } } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of clear filtersForm
export const dTicketsClearFiltersAC = createAction(
    'D_TICKETS_CLEAR_FILTERS',
)

// Action creator of set filtersForm
export const dTicketsSetFiltersAC = createAction(
    'D_TICKETS_SET_FILTERS',
    ( filterObj: typeTicketsFilters ) => ( { payload: filterObj } )
)

// Action creator of set filtersForm saga
export const dTicketsSetFiltersSagaAC = createAction(
    'D_TICKETS_SET_FILTERS_SAGA',
    (
        filtersObject: typeTicketsFilters
    ) => ( { payload: { filtersObject } } )
)

// ---------------------------------------------------------------------------------------------------------------------

// Action creator of set merchant data
export const dTicketsSetMerchantDataSagaAC=createAction(
    'D_TICKETS_SET_MERCHANT_DATA_SAGA',
    (
        merchantId: string
    ) => ( { payload: { merchantId } } )
)

export const dTicketsSetMerchantDataAC=createAction(
    'D_TICKETS_SET_MERCHANT_DATA',
    (
        dataObject: typeMerchantData
    ) => ( { payload: dataObject } )
)

// Action creator of set loader merchant data
export const dTicketsMerchantDataLoaderAC=createAction(
    'D_TICKETS_MERCHANT_DATA_LOADER',
    (
        loader: boolean
    ) => ( { payload: { loader } } )
)

// ---------------------------------------------------------------------------------------------------------------------
